module.exports = __webpack_public_path__ + "img/c08_buildingtechashokaswill_Normal_ua.681f98ff.webp";